module.exports = __webpack_public_path__ + "img/culture_01.62afc1c5.png";